export const getCoteDeNuitsData = () => ({
  name: "Côte de Nuits",
  region: "Bourgogne",
  country: "France",
  description: "La Côte de Nuits est le cœur des grands vins rouges de Bourgogne, abritant les plus prestigieux Grands Crus et produisant des vins de Pinot Noir d'exception.",
  type: "subregion",
  area: "1,600 ha",
  production: "80,000 hectolitres",
  mapAreas: [
    { region: "Côte de Nuits", x: 54, y: 58, color: "#4B164C", size: 5 }
  ],
  characteristics: {
    climate: "Climat continental tempéré, hivers froids, étés chauds",
    soil: "Sols argilo-calcaires, marnes, calcaires",
    viticulture: "Viticulture traditionnelle, rendements très limités, vendanges manuelles"
  },
  wineStyles: {
    red: "Vins rouges puissants et structurés, avec des notes de fruits rouges et d'épices",
    white: "Vins blancs complexes et riches, avec des notes de beurre et de fruits secs"
  },
  history: "La Côte de Nuits produit des vins depuis l'époque romaine. Les moines cisterciens ont développé la viticulture au Moyen Âge. La région abrite les plus prestigieux Grands Crus de Bourgogne.",
  foodPairing: "Viandes rouges, gibier, fromages affinés, cuisine gastronomique",
  grapeVarieties: [
    {
      name: "Pinot Noir",
      percentage: "85%",
      description: "Cépage roi de la Côte de Nuits, produisant des vins rouges d'exception",
      characteristics: "Puissant, structuré, tanins nobles, notes de fruits rouges et d'épices",
      wineStyles: "Sec, plein-corps, tannique"
    },
    {
      name: "Chardonnay",
      percentage: "15%",
      description: "Cépage blanc pour les vins blancs, produisant des vins complexes et riches",
      characteristics: "Complexe, riche, notes de beurre et de fruits secs",
      wineStyles: "Sec, plein-corps, complexe"
    }
  ]
}); 